import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api, { usd } from "../lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | error
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status) || attempts > 8) { setState("error"); return; }
      } catch { if (attempts > 8) { setState("error"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="relative z-10 min-h-screen flex items-center justify-center px-5">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} className="border border-[#5A2A24] bg-[#2C0D12] p-10 md:p-16 max-w-lg w-full text-center">
        {state === "checking" && (<>
          <Loader2 className="w-14 h-14 text-[#C0894F] animate-spin mx-auto mb-6" />
          <h1 className="font-display uppercase text-4xl mb-2">Confirming</h1>
          <p className="text-[#C7A98F] font-mono text-sm">Verifying your deposit with Stripe…</p>
        </>)}
        {state === "paid" && (<>
          <CheckCircle2 className="w-14 h-14 text-[#9DB562] mx-auto mb-6" />
          <h1 className="font-display uppercase text-4xl mb-2">Reserved</h1>
          <p className="text-[#C7A98F] mb-2">Your deposit is locked in.</p>
          {info?.amount && <p className="font-mono text-[#C0894F] text-xl mb-6">{usd(info.amount)} · {info.listing_title}</p>}
          <p className="text-[#8C6552] text-sm mb-8 font-mono">Our broker desk will coordinate the FFL transfer.</p>
          <div className="flex gap-3 justify-center">
            <Link to="/dashboard" className="btn-tactical">Go to Dashboard</Link>
            <Link to="/marketplace" className="btn-ghost">Keep Browsing</Link>
          </div>
        </>)}
        {state === "error" && (<>
          <XCircle className="w-14 h-14 text-[#C0894F] mx-auto mb-6" />
          <h1 className="font-display uppercase text-4xl mb-2">Unconfirmed</h1>
          <p className="text-[#C7A98F] mb-8">We couldn't confirm your payment. If you were charged, contact the desk.</p>
          <Link to="/marketplace" className="btn-ghost">Back to Marketplace</Link>
        </>)}
      </motion.div>
    </div>
  );
}
